<ng-container>
	<div fxLayout="column" style="padding:16px;">
		<div *ngIf="false" style="background: linear-gradient(#242424,#141414);">
			<div style="padding:16px; color: #fdfdfd;">
				<div class="card-title">Location {{currentSession.content.type}}</div>
				<div style="margin-top: 32px;" fxLayout="row">
					<div fxLayout="column" fxFlex="60">
						<iframe
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.5113915127517!2d139.75554301556758!3d35.66440808019819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bc37e812f85%3A0x7843dd1a4d5209ab!2zQUlHSUEg44K544K_44K444Kq!5e0!3m2!1sja!2sjp!4v1644563069287!5m2!1sja!2sjp"
							width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
					</div>
					<div fxLayout="column" style="margin-left: 24px;" fxFlex="30">
						<div fxLayout="row">
							<mat-card fxLayout="row" style="background-color: #4F4F4F;" fxLayoutAlign="center center" fxFlex="100" fxFlex.lt-md="30" fxFlex.lt-sm="100">
								<div fxLayout="row" fxLayoutAlign="center center">
									<button color="primary" mat-raised-button id="mat-search-button"><span translate>現在地から検索</span></button>
								</div>
							</mat-card>
						</div>
						<div fxLayout="row">
							<mat-card fxFlex="auto" style="background-color: #4F4F4F;margin-top:32px;"  fxFlex.lt-md="30" fxFlex.lt-sm="100">
								<h3><span translate>地域から検索</span></h3>
								<ul>
									<li>
										<a [routerLink]="['/news-description']" style="text-decoration: none;">
											<span style="font-size:12px;font-weight:600;line-height: 30px;color:#A0C020;" translate>東京</span>
										</a>
									</li>
									<li>
										<a [routerLink]="['/news-description']" style="text-decoration: none;">
											<span style="font-size:12px;font-weight:600;line-height: 30px;color:#A0C020;" translate>大阪</span>
										</a>
									</li>
								</ul>
							</mat-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="false">
			<div *ngFor="let article of location;" fxLayout="column" fxLayoutAlign="start" style="margin-top:32px;">
				<mat-card fxFlex="auto" style="background-color: #4F4F4F;">
					<mat-card-content>
						<mat-card fxFlex matRipple>
							<mat-card-content>
								<a [routerLink]="['/news-description', article.content.id]" style="text-decoration: none;">
									<div fxLayout="row" fxLayoutAlign="space-between" style="color:#fdfdfd;margin:8px;">
										<div fxlayout="column">
											<div style="font-size:12px;font-weight:600;line-height: 20px;color:#FDFDFD;">{{article.create | date:"yyyy.MM.dd"}}</div>
											<div style="font-size:12px;font-weight:600;line-height: 30px;color:#A0C020;">{{article.content.value.title}}</div>
										</div>
										<img *ngIf="!(imagePath(article.content) === '')" [src]="imagePath(article.content)" class="shadow" style="margin: auto 24px;height:100px;" alt="">
									</div>
								</a>
							</mat-card-content>
						</mat-card>
					</mat-card-content>
				</mat-card>
			</div>
		</div>
		<div style="background-color: #242424;">
			<div style="padding:16px; color: #fdfdfd;">
				<div class="card-title"><span data-idtest="news-t-6Fc" translate>ニュース・お知らせ</span> {{currentSession.content.type}}</div>
			</div>
		</div>
		<div *ngFor="let article of news;" fxLayout="column" fxLayoutAlign="start" style="margin-top:32px;">
			<mat-card fxFlex="auto" style="background-color: #4F4F4F;">
				<mat-card-content>
					<mat-card fxFlex matRipple>
						<mat-card-content>
							<a [routerLink]="['/news-description', article.content.id]" [queryParams]="params" style="text-decoration: none;">
								<div fxLayout="row" fxLayoutAlign="space-between" style="color:#fdfdfd;margin:8px;">
									<div fxlayout="column">
										<div data-idtest="news-t-8Uj" class="news-date">{{article.create | date:"yyyy.MM.dd"}}</div>
										<div data-idtest="news-t-6Pn" class="news-title">{{article.content.value.title}}</div>
									</div>
								</div>
							</a>
						</mat-card-content>
					</mat-card>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</ng-container>
